export const WEB_STORAGE_KEYS = {
  DO_PAYPAL_PURCHASE_VALUE: "doPaypalPurchaseValue",
  SELECTED_PAYMENT_ITEM: "selectedPaymentItem",
};
